import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { UserService } from '@atmi/core/services/user.service';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // TODO: Remove embedded url check
    if (req.url.includes('/sessions') || req.url.includes('/content')) {
      return next.handle(req);
    }

    return this.userService.selectQueryState('token')
      .pipe(
        distinctUntilChanged(),
        switchMap((token) => {
          // Check for undefined, null, or empty string
          if (!token || token === '' || token === 'undefined') {
            // No token available, proceed with original request
            return next.handle(req);
          }
          const authReq = req.clone({
            setHeaders: {
              Authorization: `${token}`,
            },
          });
          return next.handle(authReq);
        }),
        catchError((error) => {
          // Handle 401 Unauthorized - clear localStorage and redirect to login
          if (error.status === 401) {
            console.warn('401 Unauthorized - clearing session and redirecting to login');
            localStorage.clear();
            this.router.navigate(['/login']);
          }
          return throwError(() => error);
        }),
      );
  }
}
